import Image from 'next/image'
import { nonNullable } from '@/root/types/typeguards'
import { getImageTransformationUrl } from '@/root/utils/common/images/image-transformation'

const StencilImage = (
  props: Omit<Parameters<typeof Image>[0], 'alt'> & { alt?: string }, // This is just a temp fix till the time team adds alt tags to all components
) => {
  const finalProps = {
    alt: 'img',
    title: props.title ?? props.alt,
    ...props,
    loader({ src, width, quality }) {
      const urlQuery = `?url=/images${src}`
      return `/stencil/images${urlQuery}&w=${width}&q=${quality ?? 75}` // 75 is next.js's default
    },
  }

  return <Image {...finalProps} />
}

export default StencilImage

// const cdnLoader = ({ src }: { src: string }) => {
//   return src
// }

type TStencilCDNProps = Omit<Parameters<typeof Image>[0], 'alt'> & {
  // This is just a temp fix till the time team adds alt tags to all components
  src?: { png?: string }
} & {
  alt?: string
}

export const StencilCDNImage = (props: TStencilCDNProps) => {
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  if (!props.src) return null
  const finalProps = {
    alt: 'img',
    title: props.title ?? props.alt,
    ...props,
    src: getImageTransformationUrl(props),
    unoptimized: true,
    // Removing loader property from CDN image https://nextjs.org/docs/messages/next-image-missing-loader-width
  }

  return <Image {...finalProps} />
}

export const StencilOptimizedCDNImage = (
  props: TStencilCDNProps & { quality?: number; baseUrlProp?: string },
) => {
  const quality = props.quality ?? 90
  const srcFromProps = props.src.png ? props.src.png : props.src
  const isSrcPresent = nonNullable(srcFromProps)

  if (!isSrcPresent) {
    return null
  }

  const baseUrl =
    props.baseUrlProp ?? 'https://indcdn.indmoney.com/cdn-cgi/image'

  const src = `${baseUrl}/quality=${quality},format=auto,metadata=copyright,width=${
    props.width
  }/${srcFromProps as string}`

  const finalProps = {
    ...props,
    src,
  }
  return <StencilCDNImage {...finalProps} />
}
